import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpResponse
} from "@angular/common/http";
import { LoaderService } from "./loader.service";
import { tap } from "rxjs/operators";
import { LoggerService } from "./services/logger.service";
import { environment } from "src/environments/environment";
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(
    private logger: LoggerService,
    private _loaderService: LoaderService,
    private router: Router
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler) {

    const ignoredUrls = [
      `${environment.apiUrl}/api/ap/global/adminMembers`,
      `${environment.apiUrl}/api/ap/global/adminCorporates`,
      `${environment.apiUrl}/api/ap/global/adminAdvisors`,
      // `${environment.apiUrl}/api/ap/customer/formConfig`,
      // `${environment.langApi}/string/project-url-strings`,
      // `${environment.apiUrl}/api/ap/admin/corporateSignup/formConfig`,
      new RegExp(`${environment.apiUrl}/api/ap/\\d+/invoices`),
      new RegExp(`${environment.apiUrl}/api/ap/customer/\\d+/get-invoices`),
      new RegExp(`${environment.apiUrl}/api/ap/admin/customer/\\d+/details/rest`),
      new RegExp(`${environment.apiUrl}/api/ap/v2/rest/broker/formConfig?currentBrokerId=\\d`),
    ];
    if (ignoredUrls.some((url: any) => {
      if (url instanceof RegExp) {
        return url.test(request.url);
      } else {
        return request.url.includes(url);
      }
    })) {
      this._loaderService.HideLoader();
    }else{
      this._loaderService.ShowLoader();
    }

    return next.handle(request).pipe(
      tap(
        req => {
          if (req instanceof HttpResponse) {
            // console.log('api status code:',req.status)
            this._loaderService.HideLoader();
          }
        },
        err => {
          this._loaderService.HideLoader();

          // console.log('api status code:',err.status,err)
          // Check for 401 Unauthorized status code
          if (err.status === 401) {
            console.log('the api response code is 401')
            Swal.fire({
              title: 'Error',
              text: err.error.message || 'Session expired or unauthorized access',
              showDenyButton: false,
              showCancelButton: false,
              allowOutsideClick: false,
              confirmButtonText: 'OK',
            }).then(() => {
              sessionStorage.clear();
              setTimeout(() => {
                this.router.navigate(['/login']);
              }, 0);
            });
          }

          // when api server is down
          // if (err.status === 0 || err.status === 502) {
          //   Swal.fire({
          //     title: 'Website Under Maintenance',
          //     text: 'The API server is currently unavailable. Please try again later.',
          //     confirmButtonText: 'OK',
          //     allowOutsideClick: false,
          //     showCancelButton: false,
          //     showDenyButton: false,
          //   })
          // }
        }
      )
    );
  }
}
